import { Typography } from '@/components';
import { TransactionDetails } from '../../types';
import { useTranslation } from 'react-i18next';
import { useCompanyRole } from '@/features/company/hooks';
import { useState } from 'react';
import { columns } from './transaction-column-header';
import { TransactionsTable } from './transactions-table';

export function TransactionsDetails({ transactions }: { transactions: TransactionDetails[] }) {
  const { t } = useTranslation(['insights']);
  const { isPremium } = useCompanyRole();

  const [expandedRowId, setExpandedRowId] = useState<null | string>(null);
  const toggleRow = (id: string) => {
    setExpandedRowId((current) => (current === id ? null : id));
  };
  const tableColumns = columns({ expandedRowId, toggleRow });

  return (
    <>
      <Typography as="h1" size="heading-2" color="primary" weight="semibold" className="mb-2">
        {t('Recent Transactions')}
      </Typography>
      <Typography as="p" size="body-2" color="secondary" weight="normal">
        {t('In this section, you will find the latest transactions in renewable energy projects.')}
      </Typography>
      <div className="mt-5 space-y-3">
        <TransactionsTable
          columns={tableColumns}
          data={!isPremium ? transactions.slice(0, 3) : transactions}
          expandedRowId={expandedRowId}
          toggleRow={toggleRow}
        />
      </div>
    </>
  );
}
